const listeners = new Set();
let state = { sessionId: null, artifacts: [], loading: false, error: null };

export function getArtifactState() { return state; }

export function beginLoad(sessionId) {
  state = { sessionId, artifacts: state.sessionId === sessionId ? state.artifacts : [], loading: true, error: null };
  emit();
}

export function setArtifacts(sessionId, artifacts) {
  state = { sessionId, artifacts: Array.isArray(artifacts) ? artifacts : [], loading: false, error: null };
  emit();
}

export function setError(sessionId, error) {
  state = { sessionId, artifacts: [], loading: false, error: error?.message || "素材加载失败" };
  emit();
}

export function clearArtifacts() {
  state = { sessionId: null, artifacts: [], loading: false, error: null };
  emit();
}

export function subscribe(listener) {
  listeners.add(listener);
  listener(state);
  return () => listeners.delete(listener);
}

function emit() {
  for (const listener of listeners) listener(state);
}

export const artifactStore = Object.freeze({ getArtifactState, beginLoad, setArtifacts, setError, clearArtifacts, subscribe });
